import { axiosInstance, axiosFileBlob, axiosInstanceAll } from "../instance";

// 暂时写死的token
const usertoken = '00000000170814016735222106251438064066'

// 点播内容列表中：获取分类属性
export const getVodPlusIndexApi = (params?) => {
    const { parent } = params
    return axiosInstanceAll({
        method: 'get',
        url: '/vodPlus/getVodPlusIndex',
        params: {
            parent,
            h: '169694b374feb51b4b31ff9094908d0a96bbeb4890242f0000fec7e789de461a',
            usertoken
        }
    })
}
// 获取推荐预览图片和分类
export const getRecommendPreview = (params?) => {
    const { parent } = params
    return axiosInstanceAll({
        method: 'get',
        url: '/api/vodplusTheme/preview',
        params: {
            operationPlanId:parent,
        }
    })
}

// 获取相关推荐
export const getRelativeRecommendApi = (params) => {
    const { total } = params
    return axiosInstanceAll({
        method: 'get',
        url: '/vodPlus/getRelativeRecommend',
        params: {
            total,
            usertoken
        }
    })
}

// 获取导演或演员详情
export const getCastOrDirectorDetailApi = (params) => {
    const { nameId } = params
    return axiosInstanceAll({
        method: 'get',
        url: '/vodPlus/getCastOrDirectorDetail',
        params: {
            nameId,
            usertoken
        },
        noRepetition: true,
    })
}

// 获取vodList相关的信息 (type: 1.movie 2.series 3.record)
export const getVodListByTypeApi = (params) => {
    const { type, nameId, start, total } = params
    return axiosInstanceAll({
        method: 'get',
        url: '/vodPlus/getVodListByType',
        params: {
            type,
            nameId,
            start,
            total,
            usertoken
        },
        noRepetition: true,
    })
}

// 查询获取奖项getAwards
export const getAwardsApi = (params) => {
    const { nameId } = params
    return axiosInstanceAll({
        method: 'get',
        url: '/vodPlus/getAwards',
        params: {
            nameId,
            usertoken
        }
    })
}

// 获取个人简介 
export const getBiographyApi = (params) => {
    const { nameId } = params
    return axiosInstanceAll({
        method: 'get',
        url: '/vodPlus/getBiography',
        params: {
            nameId,
            usertoken
        }
    })
}

// 获取导演或演员列表 (type: 1.cast 演员 2.director 导演)
export const getCastOrDirectorListApi = (params) => {
    const { imdbId, type } = params
    return axiosInstanceAll({
        method: 'get',
        url: '/vodPlus/getCastOrDirectorList',
        params: {
            imdbId,
            type,
            usertoken
        }
    })
}

// 搜索电影/剧集/导演/演员接口
export const getVodPlusSearchUrlApi = (params) => {
    const { cid, start, total, search } = params
    return axiosInstanceAll({
        method: 'get',
        url: '/vodPlus/vodplusSearch',
        // url: '/vodPlus/search',
        params: {
            cid,
            start,
            total,
            search,
            usertoken
        },
        noRepetition: true,
    })
}

// 获取vodPlus收藏列表
export const getFavoritesListApi = (params) => {
    return axiosInstanceAll({
        method: 'get',
        url: '/vodPlus/getFavoritesList',
        // url: '/vodPlus/search',
        params: {
            usertoken
        },
        noRepetition: true,
    })
}

// 收藏/取消收藏
export const collectOrCancleApi = (params) => {
    const { action, categoryid, pid, sourcetype } = params
    return axiosInstanceAll({
        method: 'get',
        url: '/vodPlus/favorites?1=1',
        params: {
            action,
            categoryid,
            pid,
            sourcetype,
            usertoken
        },
        noRepetition: true,
    })
}


// 创建收藏目录
export const favoritesCategoryApi = (params) => {
    const { action, categoryname } = params
    return axiosInstanceAll({
        method: 'get',
        url: '/vodPlus/favoritesCategory',
        params: {
            action,
            categoryname,
            usertoken
        },
        noRepetition: true,
    })
}

// 获取浏览历史
export const getPlayHistoryInfoApi = (params) => {
    return axiosInstanceAll({
        method: 'get',
        url: '/vodPlus/getPlayHistoryInfo',
        params: {
            usertoken
        },
        noRepetition: true,
    })
}

// 保存播放历史
export const savePlayHistoryInfoApi = (params) => {
    const { action, id, categoryid, timeShift, programtype, seriesid, delId } = params
    return axiosInstanceAll({
        method: 'get',
        url: '/vodPlus/savePlayHistoryInfo',
        params: {
            usertoken, action, id, categoryid, timeShift, programtype, seriesid, delId
        },
        noRepetition: true,
    })
}
